import Grid from "@mui/material/Grid2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleUser } from "@fortawesome/free-solid-svg-icons";
import "./MemberPage.css";
import {useEffect, useState} from "react";

const rolePriority = {
    'CAPTAIN': 1,
    'DIRECTOR': 2,
    'UNIT_LEADER': 3,
    'OFFICIAL_CREW': 4,
    'SEMI_CREW': 5,
    'MEMBER': 6
};

function getRolePriority(role) {
    const normalizedRole = role?.toUpperCase().replace(/\s+/g, '');
    return rolePriority[normalizedRole] || rolePriority['MEMBER'];
}

function sortMembers(members) {
    return [...members].sort((a, b) => {
        const roleDiff = getRolePriority(a.role) - getRolePriority(b.role);
        if (roleDiff !== 0) return roleDiff;
        return a.name.localeCompare(b.name, 'ko-KR');
    });
}

function MemberCard({ member }) {
    return (
        <Grid item>
            <div className="member-card">
                {member.profileImage ? (
                    <img
                        src={member.profileImage}
                        alt={member.name}
                        className="member-profile-image"
                    />
                ) : (
                    <FontAwesomeIcon icon={faCircleUser} className="member-profile-image"/>
                )}
                <div className="member-role-badge">
                    {member.role}
                </div>
                <p className="profile-card-title-txt" style={{ textAlign: "center" }}>
                    {member.name}
                </p>
                <p className="profile-card-subtitle-txt" style={{ textAlign: "center" }}>
                    {member.department}
                    <br />
                    {member.unit.map((unit, index) => (
                        <span key={index} className="member-unit-tag">
                            {unit}
                        </span>
                    ))}
                </p>
            </div>
        </Grid>
    );
}

export function _UnitContainer({unit, members}) {
    const [isMobile, setIsMobile] = useState(false);
    const sortedMembers = sortMembers(members);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    return (
        <div style={{
            width: isMobile ? "100%" : "998px",
            marginBottom: isMobile ? 60 : 100,
            padding: isMobile ? "0 16px" : 0
        }}>
            <h4
                id={unit}
                className="h4-txt"
                style={{
                    color: "var(--bs-primary)",
                    paddingBottom: isMobile ? 16 : 24,
                    fontSize: isMobile ? "1.5rem" : "2rem",
                    textAlign: isMobile ? "center" : "left"
                }}>
                {unit}
            </h4>
            <Grid 
                container 
                spacing={isMobile ? 2 : 6}
                justifyContent="center"
                alignItems="stretch"
            >
                {sortedMembers.map((member, index) => (
                    <Grid item xs={6} sm={6} md={4} lg={3} key={index}>
                        <MemberCard member={member}/>
                    </Grid>
                ))}
            </Grid>
        </div>
    );
}